<template>
    <div v-if="contrato">
        <form class="form-horizontal" >
            <div class="form-group">

                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input v-model="contrato.cliente.nome" disabled type="text" class="form-control" >
                </div>

            </div>

            <list-cacontrol :ref_id="contrato.ref_id"/>

            <button @click.prevent="sincronizar()" class="btn btn-info">
                SINCRONIZAR CONTRATO
            </button>

        </form>
    </div>
</template>
<script>
/* global swal */

import { ListCacontrol } from "../../../components/exports";
import { Contratos } from "../../../class/index";
import contratoMixin from "../../mixins/contrato";
export default {
    components: {
        ListCacontrol
    },
    mixins: [contratoMixin],
    methods: {
        sincronizar() {
            Contratos.sync(this.contrato._id)
                .then(() => {
                    swal(
                        "Contrato!",
                        "O Contrato foi sincronizado, atualize a página!",
                        "success"
                    );
                })
                .catch(err => {
                    swal(
                        "Contrato!",
                        "O Contrato NÃO foi sincronizado!",
                        "error"
                    );
                    console.error(err);
                });
        }
    }
};
</script>
